export class MassiveLoadResult {

  resultado: boolean;
  erroresValidacion: ErrorValidacion[];
  registrosExcel: MassiveLoadExcelField[][];
  mensajeGeneral: string;
  numeroCamposRegistro: number;
  isInventario: boolean;

  constructor() { }

  static toModel(json: string): MassiveLoadResult {
    const data = JSON.parse(json);
    const toReturn = new MassiveLoadResult();

    toReturn.resultado = data.Resultado;
    if (data.ErroresEnValidacion) {
      toReturn.erroresValidacion = data.ErroresEnValidacion.map((error: any) => ErrorValidacion.toModel(JSON.stringify(error)));
    }
    if (data.RegistrosExcel) {
      toReturn.registrosExcel = data.RegistrosExcel.map((registros: any) =>
        registros.Campos.map((registro: any) => MassiveLoadExcelField.toModel(JSON.stringify(registro))));
    }
    toReturn.mensajeGeneral = data.MensajeGeneral;
    toReturn.numeroCamposRegistro = data.NumeroCamposRegistro;
    toReturn.isInventario = data.isInventario;

    return toReturn;
  }

}


export class ErrorValidacion {

  private field: string;
  private errorMessage: string;
  private address: string;

  constructor() { }

  static toModel(json: string): ErrorValidacion {
    const data = JSON.parse(json);
    const toReturn = new ErrorValidacion();

    toReturn.field = data.Field;
    toReturn.errorMessage = data.ErrorMessage;
    toReturn.address = data.Address;

    return toReturn;
  }

}

export class MassiveLoadExcelField {

  nombreCampo: string;
  valor: string;
  principal: boolean;
  id: number;

  constructor() { }

  static toModel(json: string): MassiveLoadExcelField {
    const data = JSON.parse(json);
    const toReturn = new MassiveLoadExcelField();

    toReturn.nombreCampo = data.NOMBRE_CAMPO;
    toReturn.valor = data.VALOR;
    toReturn.principal = data.PRINCIPAL;
    toReturn.id = data.ID;

    return toReturn;
  }

}

export class FileData {
  filename: string;
  size: string;
  guid: string;
  extension: string;
  file: File;

  constructor() { }
}

